import { ApSimpleDropdown } from '@alixpartners/ui-components';
import React from 'react';
import {
  IApplicationSpendItem,
  ICurrencyFormat,
  IDisplayByType,
} from 'utils/types';
import ApplicationsTable from '../../components/Tables/ApplicationsTable/ApplicationsTable';
import {
  HeaderLabel,
  HeaderTop,
  SectionWrapper,
  TopDataContent,
} from './Applications.styles';
import { EXPORT_OPTIONS } from 'utils/constants';

export const ApplicationsTableContainer = ({
  applications,
  displayBy,
  downloadApplicationSummaryData,
  format,
  selectedGroup,
  selectedApplication,
  showSuccessNotification,
}: {
  applications: IApplicationSpendItem[];
  displayBy: IDisplayByType;
  downloadApplicationSummaryData: () => Promise<any>;
  format: ICurrencyFormat;
  selectedGroup?: string;
  selectedApplication?: string;
  showSuccessNotification: () => void;
}) => {
  const displayText = displayBy === IDisplayByType.COST ? 'Spend' : 'Headcount';
  let headerText = `${displayText} summary by application`;
  if (selectedGroup) {
    headerText = `${displayText} summary by ${selectedGroup} application`;
  } else if (selectedApplication) {
    headerText = `${displayText} summary for ${selectedApplication}`;
  }
  return (
    <SectionWrapper>
      <HeaderTop>
        <HeaderLabel>{headerText}</HeaderLabel>
        <ApSimpleDropdown
          iconName="outline_save_alt"
          onChange={(opt: any) => {
            if (opt.value === 'xlsx') {
              downloadApplicationSummaryData().then(showSuccessNotification);
            }
          }}
          options={[EXPORT_OPTIONS[1]]}
          label="Export"
        />
      </HeaderTop>
      <TopDataContent>
        <ApplicationsTable
          isHeadcount={displayBy === IDisplayByType.HEADCOUNT}
          rowData={applications.map((app) => ({
            ...app,
            isHighlighted: app.applicationName === selectedApplication,
          }))}
          format={format}
        />
      </TopDataContent>
    </SectionWrapper>
  );
};
